import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1e88e5;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 26rem;
  padding: 2.5rem 2rem 3rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);

  > svg {
    margin-bottom: 2rem;
  }

  form {
    width: 100%;
    display: flex;
    flex-direction: column;

    h1 {
      font-family: 'RedHatDisplay-Bold';
      font-size: 1.34rem;
      margin: 0 0 0.25rem;
    }

    p.description {
      font-family: 'RedHatDisplay-Regular';
      font-size: 0.85rem;
      color: #666;
      line-height: 1.5;
      margin: 0 0 1.5rem;
    }

    > span {
      font-family: 'RedHatDisplay-Regular';
      font-size: 0.88rem;
      margin-bottom: 0.3rem;
    }

    .primary-button {
      margin-top: 1.5rem;
      height: 3.33rem;
      font-family: 'RedHatDisplay-Bold';
      font-size: 1.1rem;
      border-radius: 0.55rem;
      box-shadow: 0px 3px 15px rgba(255, 152, 0, 0.3);
    }
  }
`;

export const StatusMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 0;

  .spinner {
    width: 2.5rem;
    height: 2.5rem;
    border: 3px solid #f0f0f0;
    border-top-color: #ff9800;
    border-radius: 50%;
    animation: ${spin} 0.8s linear infinite;
  }

  p {
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.9rem;
    color: #666;
    margin: 0;
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.75rem;
  padding: 1rem 0;

  .error-icon {
    font-size: 3rem;
  }

  h2 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.2rem;
    color: #333;
    margin: 0;
  }

  p {
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.88rem;
    color: #666;
    line-height: 1.5;
    margin: 0;
  }

  button {
    margin-top: 0.5rem;
    background: none;
    border: 2px solid #ff9800;
    border-radius: 0.5rem;
    padding: 0.6rem 1.5rem;
    font-family: 'RedHatDisplay-Bold';
    font-size: 0.9rem;
    color: #ff9800;
    cursor: pointer;
    transition:
      background-color 0.2s ease,
      color 0.2s ease;

    &:hover {
      background-color: #ff9800;
      color: #fff;
    }

    &:focus-visible {
      outline: 2px solid #ff9800;
      outline-offset: 2px;
    }
  }
`;
